const Disclaimer = () => {
    return (
        <>
            <div className="col-lg-7 col-xl-8 px-3">
                <p className="fw-800 fs14 disclaimer">Disclaimer</p>
                <p className="fw-400 fs14 t-grey-400">
                    All of the above requested information is mandatory to open a brokerage account at Next Capital Limited. The requested information conforms to the rules and regulations set by the relevant regulatory authorities  and institutions (SECP, PSX, NCCPL, CDC).
                </p>
            </div>
        </>
    );
}
export default Disclaimer;